import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { DashboardComponent } from './modules/dashboard/dashboard.component';
import { HotelComponent } from './modules/hotel/hotel.component';
import { LoginComponent } from './modules/login/login.component';
import { DefaultLayoutComponent } from './shared/components/default-layout/default-layout.component';
import { OfficeLeaseComponent } from './modules/office-lease/office-lease.component';
import { GolfComponent } from './modules/golf/golf.component';
import { EventsActivitiesComponent } from './modules/events-activities/events-activities.component';
import { ResidencesComponent } from './modules/residences/residences.component';
import { SalesActivitiesComponent } from './modules/sales-activities/sales-activities.component';
import { UserprofileComponent } from './modules/userprofile/userprofile.component';
import { AuthGuard } from './core/guards/auth.guard';
import { BusinessLineGuard } from './core/guards/business-line.guard'; // Import BusinessLineGuard
import { Server404Component } from './modules/server-404/server-404.component';
import { Server500Component } from './modules/server-500/server-500.component';
import { SalesActivitiesDetailComponent } from './modules/sales-activities-detail/sales-activities-detail.component';
import { TenantListComponent } from './modules/tenant-list/tenant-list.component';
import { HotelDetailComponent } from './modules/hotel-detail/hotel-detail.component';
import { OfficeLeaseDetailComponent } from './modules/office-lease-detail/office-lease-detail.component';
import { TenantBusinessDetailComponent } from './modules/tenant-business-detail/tenant-business-detail.component';
import { ResidencesDetailComponent } from './modules/residences-detail/residences-detail.component';
import { SalesListComponent } from './modules/sales-list/sales-list.component';
import { SalesListDetailComponent } from './modules/sales-list-detail/sales-list-detail.component';

const routes: Routes = [
  {
    path: '',
    redirectTo: 'dashboard',
    pathMatch: 'full'
  },
  {
    path: 'login',
    component: LoginComponent,
    title: 'Login - MNC Tourism Indonesia' // TW20250804: Updated title to include MNC Tourism Indonesia
  },
  {
    path: '',
    component: DefaultLayoutComponent,
    canActivate: [AuthGuard, BusinessLineGuard],
    canActivateChild: [AuthGuard, BusinessLineGuard],
    children: [
      {
        path: 'dashboard',
        component: DashboardComponent,
        title: 'Dashboard - MNC Tourism Indonesia' // TW20250804: Updated title to include MNC Turism Indonesia
      },
      {
        path: 'userprofile',
        component: UserprofileComponent,
        title: 'User Profile'
      },
      {
        path: 'hotel',
        canActivate: [AuthGuard, BusinessLineGuard],
        canActivateChild: [AuthGuard, BusinessLineGuard],
        children: [
          {
            path: '',
            component: HotelComponent,
            title: 'Hotel'
          },
          {
            path: 'hotel-detail/:id',
            component: HotelDetailComponent,
            title: 'Detail Hotel'
          },
        ]
      },
      {
        path: 'office-lease',
        canActivate: [AuthGuard, BusinessLineGuard],
        canActivateChild: [AuthGuard, BusinessLineGuard],
        children: [
          {
            path: '',
            component: OfficeLeaseComponent,
            title: 'Office Lease'
          },
          {
            path: 'detail-office-lease/:id',
            component: OfficeLeaseDetailComponent,
            title: 'Detail Office Lease'
          },
          {
            path: 'tenant-list',
            canActivate: [AuthGuard, BusinessLineGuard],
            canActivateChild: [AuthGuard, BusinessLineGuard],
            children: [
              {
                path: '',
                component: TenantListComponent,
                title: 'Tenant List'
              },
              {
                path: 'business-unit-detail/:id',
                component: TenantBusinessDetailComponent,
                title: 'Business Unit Detail'
              }
            ],
          },
        ]
      },
      {
        path: 'golf',
        component: GolfComponent,
        canActivate: [AuthGuard, BusinessLineGuard],
        title: 'Golf'
      },
      {
        path: 'residences',
        canActivate: [AuthGuard, BusinessLineGuard],
        canActivateChild: [AuthGuard, BusinessLineGuard],
        children: [
          {
            path: '',
            component: ResidencesComponent,
            title: 'residences'
          },
          {
            path: 'detail-residences/:id',
            component: ResidencesDetailComponent,
            title: 'Detail Residence'
          }
        ],
      },
      {
        path: 'sales-activities',
        canActivate: [AuthGuard, BusinessLineGuard],
        canActivateChild: [AuthGuard, BusinessLineGuard],
        children: [
          {
            path: '',
            component: SalesActivitiesComponent,
            title: 'sales-activities'
          },
          {
            path: 'sales-list',
            component: SalesListComponent,
            title: 'sales-list'
          },
          {
            path: 'sales-list/detail/:id',
            component: SalesListDetailComponent,
            title: 'sales-list-detail'
          },
          {
            path: 'sales-activities-detail/:id',
            component: SalesActivitiesDetailComponent,
            title: 'sales-activities'
          },
        ]
      },
    ]
  },
  {
    path: '404',
    component: Server404Component,
    title: '404'
  },
  {
    path: '500',
    component: Server500Component,
    title: '500'
  },
  {
    path: '**',
    redirectTo: '/404' // Redirect ke 404 instead of dashboard untuk handle invalid routes
  }
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
